export const Homevideo = function (props) {
  return <video className="w-full md:w-3/4 mx-auto" src={props.src} controls />;
};
